"<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :is-show-search-input="true"
    :push-list="RouteConfig.courseWhitelistList.push"
    search-placeholder="输入名称进行搜索"
  >
    <v-column-time/>
    <el-table-column label="白名单 ID" width="300" prop="id"/>
    <el-table-column label="白名单名称" width="300" prop="course_whitelist_name"/>
    <el-table-column label="白名单人数" width="300" prop="student_count"/>

    <el-table-column label="操作" width="300">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.courseWhitelistManage.to(row.id)" name="管理"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="白名单将会删除，对应课程将取消白名单限制，确认要继续操作吗？"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`course-whitelist-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>白名单 ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>白名单名称</span>
              <span>{{ v.course_whitelist_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>白名单人数</span>
              <span>{{ v.student_count }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.courseWhitelistManage.to(v.id)" name="管理"/>

              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="白名单将会删除，对应课程将取消白名单限制，确认要继续操作吗？"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, destroy } from '@/api/course-whitelist';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.courseWhitelistList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    isLoading: false,
    isDeleting: {},
    isGetting: {},
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time }) {
      if (!id) return this.$message.warning('缺少白名单 ID，无法删除该白名单！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, { update_time });
      this.$set(this.isDeleting, id, false);

      if (!isError) this.load();
    },
  },
};
</script>"
